<app-menu>   <div class="toolbar">
  <button (click)="exportToCSV()">
    <mat-icon>file_download</mat-icon> Export to CSV
  </button>
  <button (click)="exportToExcel()">
    <mat-icon>file_download</mat-icon> Export to Excel
  </button>
  <button class="theme-toggle" (click)="toggleTheme()">
    <mat-icon>{{ theme === 'ag-theme-ulaap' ? 'nights_stay' : 'wb_sunny' }}</mat-icon> Toggle Theme
  </button>
  <button (click)="resetToDefaultState()">
    <mat-icon>refresh</mat-icon> Default State
  </button>
  <button class="group-button" (click)="groupByConsolidationId()">
    <mat-icon>group_work</mat-icon> Group Consolidations
  </button>
</div>
  
  <ag-grid-angular
    *ngIf="gridReady"
    style="width: 100%; height: calc(100vh - 50px);"
    [rowData]="rowData"
    [class]="theme"
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    [initialState]="initialState"
    (stateUpdated)="onStateUpdated($event)"
    [components]="components"
    (cellValueChanged)="onCellValueChanged($event)"
  >
  </ag-grid-angular> </app-menu>
